import React from "react";
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/Project.scss';

function Project() {
    const { content } = useContent();
    const projects = content.projects;

    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            {projects.map((project, index) => (
                <div key={index} className="project">
                    <a href={project.link} target="_blank" rel="noreferrer"><img src={project.image} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a href={project.link} target="_blank" rel="noreferrer"><h2>{project.title}</h2></a>
                    <p>{project.description}</p>
                </div>
            ))}
        </div>
    </div>
    );
}

export default Project;